export const SERVICE_TYPE = {
    IAMSCHOOL: 'IAMSCHOOL',
    IAMSTUDENT: 'IAMSTUDENT',
};
